import { makeStyles, tokens } from '@fluentui/react-components';
import React from 'react';

const useStyles = makeStyles({
    container: {
        padding: `0 ${tokens.spacingHorizontalL}`,
        height: '100%',
        overflow: 'auto',
    },
});

const Korrespondenz: React.FC = () => {
    const styles = useStyles();

    return (
        <div className={styles.container}>
            <h1>Korrespondenz</h1>
            <p>Verwaltung und Übersicht der Korrespondenz</p>
        </div>
    );
};

export default Korrespondenz;
